import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const DotsVerticalGlyph = /*#__PURE__*/createElement("g", {
  id: "more_vertical"
}, /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "62.9",
  r: "5.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "42",
  r: "5.7"
}), /*#__PURE__*/createElement("circle", {
  cx: "42",
  cy: "21.1",
  r: "5.7"
}));
const DotsVertical = createSvg({
  name: 'dots_vertical',
  path: DotsVerticalGlyph
});

export default DotsVertical;
export { DotsVerticalGlyph };
